import React, { useEffect } from 'react';
import './FoundersModal.css';

const founders = [
  {
    id: 1,
    name: 'Puja Sharma',
    role: 'Founder & Director',
    photo: '/team/puja.webp',
    initials: 'PS',
    color: '#2563eb',
    bio: 'An academic leader turned entrepreneur with 10+ years of experience in higher education, Puja is driving CampusXL’s vision of bridging academia and industry through scalable, outcome-driven education models. She specializes in building university partnerships, enhancing employability, and creating future-ready learning ecosystems aligned with industry needs.',
    highlights: [
      '10+ years in higher education',
      'Ex - EduTech Partnership Lead',
      'Punjab University Alumni',
    ],
    linkedin: 'https://www.linkedin.com/in/puja-sharma-a25a54114/',
  },
];

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" width="14" height="14">
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

const FounderCard = ({ founder }) => (
  <div className="fc-card">

    {/* Row 1: avatar + name/role + linkedin */}
    <div className="fc-top-row">
      <div
        className="fc-avatar"
        style={founder.photo ? {} : { background: founder.color }}
      >
        {founder.photo
          ? <img src={founder.photo} alt={founder.name} className="fc-avatar-img" />
          : founder.initials}
      </div>
      <div className="fc-name-block">
        <h3 className="fc-name">{founder.name}</h3>
        <p className="fc-role">{founder.role}, CampusXL</p>
      </div>
      <a
        href={founder.linkedin}
        target="_blank"
        rel="noreferrer"
        className="fc-linkedin"
        aria-label={`${founder.name} LinkedIn`}
      >
        <LinkedInIcon />
        LinkedIn
      </a>
    </div>

    {/* Row 2: bio + highlights */}
    <div className="fc-body">
      <p className="fc-bio">{founder.bio}</p>
      <ul className="fc-highlights">
        {founder.highlights.map((h) => (
          <li key={h}>{h}</li>
        ))}
      </ul>
    </div>

  </div>
);

const FoundersModal = ({ onClose }) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  return (
    <div className="fm-overlay" onClick={onClose}>
      <div className="fm-container" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="fm-header">
          <div>
            <h2 className="fm-title">Meet the Founders</h2>
            <p className="fm-subtitle">The people building CampusXL from the ground up.</p>
          </div>
          <button className="fm-close" onClick={onClose} aria-label="Close"><CloseIcon /></button>
        </div>

        {/* Cards */}
        <div className="fm-body">
          {founders.map((f) => (
            <FounderCard key={f.id} founder={f} />
          ))}
        </div>

      </div>
    </div>
  );
};

export default FoundersModal;
